import { GenIcon } from '../helpers/IconBase.es.js';

const ClockFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM16.0424 14.1001C16.4566 14.1042 16.7958 13.7719 16.8 13.3577C16.8041 12.9435 16.4718 12.6043 16.0576 12.6001L13.7894 12.5772C13.2137 12.5714 12.75 12.103 12.75 11.5273V8.4001C12.75 7.98588 12.4142 7.6501 12 7.6501C11.5858 7.6501 11.25 7.98588 11.25 8.4001V11.5273C11.25 12.9256 12.376 14.063 13.7742 14.0771L16.0424 14.1001Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { ClockFilled };
